import axios from 'axios';
import { normalizeErrorMessage } from './publicError';

const apiClient = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('gurdwara_token');
  const rawUser = localStorage.getItem('gurdwara_user');
  let actor = null;

  if (rawUser) {
    try {
      actor = JSON.parse(rawUser);
    } catch {
      actor = null;
    }
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (actor?.email) {
    config.headers['X-Actor-Email'] = String(actor.email).toLowerCase();
  }
  if (actor?.role) {
    config.headers['X-Actor-Role'] = String(actor.role);
  }
  if (actor?.name) {
    config.headers['X-Actor-Name'] = String(actor.name);
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    error.message = normalizeErrorMessage(error, 'Unable to complete the request right now.', 'apiClient');
    return Promise.reject(error);
  }
);

export default apiClient;
